import React from 'react'
import Layout from '../components/layout'
import { graphql, useStaticQuery, Link } from 'gatsby'
//import { GatsbyImage, getImage, getSrc } from 'gatsby-plugin-image'
import Seo from '../components/seo'

const SistemasIncedio = () => {
  const data = useStaticQuery(
    graphql`
      {
        allWpPost(
          filter: {
            categories: { nodes: { elemMatch: { name: { eq: "sistemas" } } } }
          }
        ) {
          nodes {
            id
            title
            excerpt
            uri
            featuredImage {
              node {
                sourceUrl
                srcSet
                altText
              }
            }
          }
        }
      }
    `
  )

  const { allWpPost } = data

  return (
    <Layout>
      <Seo
        title='Sistemas contra incendio'
        description='Los sistemas automatizados contra incendio de Amerex protegen su patrimonio 24 horas durante todos días, requieren de poco mantenimiento y cuenta con diferentes tipos de agentes extinguidores para uso en espacios especiales.'
      ></Seo>
      <div className='d-flex flex-wrap px-4 my-5'>
        <div className='col-12 col-md-8 text-center mx-auto'>
          <h1>SISTEMAS CONTRA INCENDIOS</h1>
          <p className='lead text-danger fw-bold'>
            PROTECCIÓN AUTOMATIZADA CONTRA EL FUEGO SIN INTERRUPCIONES
          </p>
          <p>
            Los sistemas de protección contra incendios de Amerex cumplen y en
            algunos casos exceden las normativas de ley en estos rubros. Proteja
            sus instalaciones los 365 días del año, acérquese a uno de nuestros
            representantes para obtener mayor información.
          </p>
        </div>
        <div className='d-flex flex-wrap flex-column col-12 mx-auto justify-content-center align-items-center'>
          {allWpPost.nodes.map(({ id, title, excerpt, featuredImage, uri }) => (
            <div key={id} className='col-12 col-md-5 bg-grey-light m-1 p-3'>
              <img
                className='card-img-top p-3 img-fluid'
                src={featuredImage.node.sourceUrl}
                srcSet={featuredImage.node.srcSet}
                alt={featuredImage.node.altText}
              />
              {/* <GatsbyImage
                className='mb-3'
                image={getImage(
                  featuredImage.node.localFile.childImageSharp.gatsbyImageData
                )}
                content={getSrc(
                  featuredImage.node.localFile.childImageSharp.gatsbyImageData
                )}
                // image={
                //   featuredImage.node.localFile.childImageSharp.gatsbyImageData
                // }
                alt={featuredImage.node.altText}
              /> */}
              <p className='text-uppercase text-center fw-bold lead fs-5 m-0'>
                {title}
              </p>
              <p>{excerpt.replace(/(<([^>]+)>)/gi, ' ')}</p>
              <div className='d-grid gap-2'>
                <Link className='btn btn-danger fs-5' type='button' to={uri}>
                  Ver detalles
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </Layout>
  )
}

export default SistemasIncedio
